// General Selectors
export const currentTenantSelector = (state) => state?.app?.profile?.tenant;
export const originalTenantSelector = (state) => state?.app?.profile?.originalTenant;

// Models Selectors
export const modelSelector = (state) => state?.modelView?.model;
export const equalTypeSelector = (state) => state?.modelView?.equalType;
